import React from "react";

interface CustomerTopBarProps {
	collapsed: boolean;
}

// CU-14ygtkj8nr3: structure only — sibling tasks add customer-safe actions here; nothing inactive is rendered meanwhile.
const CustomerTopBar: React.FC<CustomerTopBarProps> = ({ collapsed }) => (
	<header className={`mg-topbar${collapsed ? " sidebar-collapsed" : ""}`} data-testid="customer-topbar">
		<div style={{ flex: 1 }} />
	</header>
);

export default CustomerTopBar;
